import { createFileRoute, useChildMatches } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, RouteName } from '@mews-commander/enums';
import { fetchCurrentEnterpriseReservationsByReservationIds } from '@mews-commander/legacy-entities';
import {
    RESERVATION_BARE_MINIMUM_EXTENT,
    ReservationDetailContainer,
} from '@mews-commander/modules/src/modules/reservationModule';
import { Redirect } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Reservation/Detail/$reservationId')({
    beforeLoad: ({ context: { checkPrivilege } }) => {
        checkPrivilege('manageReservations');
    },
    loader: ({ params: { reservationId }, context: { dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED }, cause }) => {
        if (cause === 'enter') {
            void dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED(
                fetchCurrentEnterpriseReservationsByReservationIds({
                    extent: { ...RESERVATION_BARE_MINIMUM_EXTENT, purchaseOrderNumbers: true },
                    reservationIds: [reservationId],
                    endUtc: undefined,
                    timeFilter: undefined,
                    startUtc: undefined,
                    states: undefined,
                })
            );
        }
    },
    component: Component,
    staticData: {
        excludeBreadcrumb: true,
        routeName: RouteName.ReservationDetail,
        owner: MewsTeam.Reservations,
        type: RouteType.Frontend,
    },
});

function Component() {
    const { reservationId, currentEnterpriseId } = Route.useParams();
    const { staticData } = Route.useMatch();
    const childMatches = useChildMatches();

    if (staticData.routeName === RouteName.ReservationDetail && !childMatches.length) {
        return (
            <Redirect
                to="/$currentEnterpriseId/Reservation/Detail/$reservationId/Status"
                params={{ currentEnterpriseId, reservationId }}
            />
        );
    }

    const guideLink = createGuideLink(ArticlePath.WhatReservationModuleWhatFeatures);

    return <ReservationDetailContainer key={reservationId} reservationId={reservationId} guideLink={guideLink} />;
}
